import React, { useEffect } from 'react'

// Hooks import
import useMediaQuery from '../../hooks/useMediaQuery'
import { useSettings } from '../../hooks/useSetting'

// Component Imports
import PermanentSidebarDrawer from './drawer/PermanentSidebarDrawer'
import SidebarDrawer from './drawer/SidebarDrawer'
import Navbar from './navbar/Navbar'
import UserRoutes from '../../routes/user/UserRoutes'


// import { getRegulator } from '../../api/privateApi'

const UserLayout = () => {

    // Hooks
    const { updateSettings } = useSettings()
    const isBreakPointReached = useMediaQuery('1200px')


    useEffect(() => {
        if (isBreakPointReached) {
            updateSettings({ isDrawerOpen: false, drawer: 'temp' }, false)
        } else {
            updateSettings({ isDrawerOpen: true, drawer: 'permanent' }, false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBreakPointReached])

    return (
        <div className="flex">
            {isBreakPointReached ? <SidebarDrawer /> : <PermanentSidebarDrawer />}
            <div className='flex-1 min-w-0 pb-6 px-6 xl:px-10 h-full overflow-y-auto'>
                <Navbar />
                <div className='mt-8'>
                    <UserRoutes />
                </div>
            </div>
        </div>
    )
}

export default UserLayout